import { Link, useLoaderData } from "react-router-dom";
import { Helmet } from "react-helmet";
import AllPageComponent from "../components/all-page-component/all-page-component";

function ResourcesListItem(props) {
  return (
    <li key={props.id}>
      <Link to={props.id}>{props.title}</Link>
    </li>
  );
}

export default function AllAuthorsPage(props) {
  const pageData = Object.fromEntries(
    Object.entries(useLoaderData().Index).map(([k, v]) => [
      k,
      v.map((author) => {
        return { Title: author.Name, ID: author.Slug };
      }),
    ])
  );
  return (
    <main className="main all-page authors">
      <Helmet>
        <title>All Authors | Wolfram Demonstrations Project</title>
      </Helmet>
      <AllPageComponent
        pageName="All Authors"
        pageData={pageData}
        ListItemComponent={ResourcesListItem}
        showLinkToAll={true}
      />
    </main>
  );
}
